<section class="card-section">
  <div class="container p-0">
    <div class="">
      <div class="col-xxl-4 col-lg-5 col-md-6 col-sm-8 col-12 p-0 m-auto">
        <div class="d-flex align-items-center justify-content-center vh-100 coverflow-hidden">
          <div class="card">
            <img src="{{baseURl}}/images/pixtar-white-logo.svg" class="card-logo" alt="best web design company in dubai pixtar" width="" height="" loading="lazy"/>
            <img src="{{baseURl}}/images/kbn.jpg" class="card-img-top" alt="kbn business image" width="" height="" loading="lazy">
            <div class="card-body d-flex flex-column justify-content-md-center justify-content-sm-center justify-content-start">
              <div class="profile-name text-center">
                <h4>KBN</h4>
                <p class="">Co-Founder & Creative Director</p>
              </div>
              <div class="account-block">
                <div class="content1">
                  <div class="content2">
                    <div class="mb-2 d-flex">
                      <div class="text-center ph me-sm-2 me-2"> <a href="tel:971527930781"> <img
                            src="{{baseURl}}/images/phone.svg" alt="Creative agency Dubai" width="" height="" loading="lazy"> </a></div>
                      <div class=""> <a href="tel:971527930781"> <span>+971 52 793 0781</span></a> </div>
                    </div>
                    <div class="d-flex">
                      <div class="text-center em me-sm-2 me-2"> <a href="mailto:kbn@pixtar.ae" target="_blank"><img
                            src="{{baseURl}}/images/email.svg" alt="Branding agency in Dubai" width="" height="" loading="lazy"> </a></div>
                      <div class=""> <a href="mailto:kbn@pixtar.ae" target="_blank">
                          <span>kbn@pixtar.ae</span></a> </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="social-links">
                <div class="d-flex flex-row justify-content-center contact ">
                  <a href="{{baseURl}}kbn.vcf" class="contact-btn">Save Contact</a>
                  <p> <a href="/"> <img src="{{baseURl}}/images/website.svg" alt="web designing agency dubai" width="35" height="" loading="lazy"> </a></p>
                  <p> <a href="https://www.linkedin.com/in/kbnab" target="_blank"> <img
                        src="{{baseURl}}/images/linkedin.svg" alt="Top branding agency in Dubai" width="35" height="" loading="lazy"> </a></p>
                  <p> <a href="https://instagram.com/imkbn?igshid=YmMyMTA2M2Y=" target="_blank"> <img
                        src="{{baseURl}}/images/instagram.svg" alt="website development company dubai" width="35" height="" loading="lazy"></a></p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>